import axios2 from "@/axios";
import axios from "axios";
import moment from "moment";

const state = {
  selectedStandingOrder: null,
  standingOrders: [],
  standingOrderTrolly: null,
};

const getters = {
  retrieveAllStandingOrders: (state) => {
    return state.standingOrders;
  },

  retrieveCurrentStandingOrder: (state) => {
    if (state.selectedStandingOrder) {
      return state.selectedStandingOrder;
    } else {
      return false;
    }
  },

  retrieveStandingOrderTrolly: (state) => {
    let trolly = false;

    if (state.selectedStandingOrder && state.standingOrderTrolly) {
      state.standingOrderTrolly.forEach((item) => {
        console.log(item.id);
        console.log(state.selectedStandingOrder.trolly_id);

        if (item.id == state.selectedStandingOrder.trolly_id) {
          trolly = item;

          // trolly = state.trollys[state.selectedTrolly];

          trolly.order_date_display = moment(trolly.order_date).format(
            "dddd, Do MMMM YYYY"
          );

          let trollyValue = 0;
          let totalQty = 0;
          let totalItems = 0;
          Object.keys(trolly.trolly_items).forEach(function(key) {
            //returns dist no as keys for the trolly
            let distValue = 0;
            let distQty = 0;
            let distItems = 0;

            //totalQty += parseFloat(trolly.trolly_items[key].qty);
            totalItems += Object.keys(trolly.trolly_items[key].items).length;
            distItems += Object.keys(trolly.trolly_items[key].items).length;

            Object.keys(trolly.trolly_items[key].items).forEach(function(prod) {
              let itemValue = 0;

              totalQty += parseFloat(trolly.trolly_items[key].items[prod].qty);
              distQty += parseFloat(trolly.trolly_items[key].items[prod].qty);

              switch (trolly.trolly_items[key].items[prod].qty_type) {
                case "B":
                  itemValue =
                    trolly.trolly_items[key].items[prod].box_price *
                    parseFloat(trolly.trolly_items[key].items[prod].qty);

                  trolly.trolly_items[key].items[prod].itemType = "Box";
                  trolly.trolly_items[key].items[prod].itemPrice = parseFloat(
                    trolly.trolly_items[key].items[prod].box_price
                  ).toFixed(2);
                  trolly.trolly_items[key].items[prod].itemValue = parseFloat(
                    itemValue
                  ).toFixed(2);
                  trollyValue += itemValue;
                  distValue += itemValue;
                  break;
                case "K":
                  itemValue =
                    trolly.trolly_items[key].items[prod].kilo_price *
                    parseFloat(trolly.trolly_items[key].items[prod].qty);

                  trolly.trolly_items[key].items[prod].itemType = "Kilo";
                  trolly.trolly_items[key].items[prod].itemPrice = parseFloat(
                    trolly.trolly_items[key].items[prod].kilo_price
                  ).toFixed(2);
                  trolly.trolly_items[key].items[prod].itemValue = parseFloat(
                    itemValue
                  ).toFixed(2);
                  trollyValue += itemValue;
                  distValue += itemValue;
                  break;
                case "E":
                  itemValue =
                    trolly.trolly_items[key].items[prod].each_price *
                    parseFloat(trolly.trolly_items[key].items[prod].qty);

                  trolly.trolly_items[key].items[prod].itemType = "Each";
                  trolly.trolly_items[key].items[prod].itemPrice = parseFloat(
                    trolly.trolly_items[key].items[prod].each_price
                  ).toFixed(2);
                  trolly.trolly_items[key].items[prod].itemValue = parseFloat(
                    itemValue
                  ).toFixed(2);
                  trollyValue += itemValue;
                  distValue += itemValue;
                  break;
              }
            });
            //Set Dist Values
            distValue = parseFloat(distValue).toFixed(2);

            trolly.trolly_items[key].distValue = distValue;
            trolly.trolly_items[key].distQty = distQty;
            trolly.trolly_items[key].distItems = distItems;
          });

          trollyValue = parseFloat(trollyValue).toFixed(2);
          trolly.totalValue = trollyValue;
          trolly.totalQty = totalQty;
          trolly.totalItems = totalItems;
        }
      });
    }

    return trolly;
  },

  retrieveStandingOrderRepeatDays: (state) => {
    let selectedDays = [];

    let daysOfWeek = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    if (state.selectedStandingOrder) {
      daysOfWeek.forEach((day) => {
        if (state.selectedStandingOrder[day] == 1) {
          selectedDays.push(day);
        }
      });
      return selectedDays;
    } else {
      return selectedDays;
    }
  },
};

const actions = {
  async getStandingOrders({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("standing/get-standing-orders", params);

    if (response.data.success == true) {
      console.log("-- Standing Orders Response Data");
      console.log(response.data);
      commit("setStandingOrders", response.data.standingOrders);
      return response.data.standingOrders;
    } else {
      response.data.success;
    }
  },

  async getStandingOrder({ commit, state }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      soId: state.selectedStandingOrder.id,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("standing/get-standing-orders", params);
    if (response.data.success) {
      commit("setSelectedStandingOrder", response.data.standingOrders[0]);
    }
    return response.data;
  },

  async disableSO({ state }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      soId: state.selectedStandingOrder.id,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post(
      "standing/disable-standing-order",
      params
    );
    return response.data;
  },

  async setSelectedStandingOrder({ commit }, order) {
    commit("setSelectedStandingOrder", order);
  },

  async createNewStandingOrderTrolly({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      standingOrder: 1,
      orderDate: orderInfo.orderDate,
      name: orderInfo.name,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("create-new-trolly", params);

    if (response.data.success == true) {
      return response.data;
    } else {
      return false;
    }
  },
  async getStandingOrderTrolly({ commit, state }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: state.selectedStandingOrder.trolly_id,
      customerNo : this.getters.retrieveSelectedCustomer,
      standingOrder: 1,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("trolly/get-trollys", params);

    if (response.data.success == true) {
      console.log("-- Trollies Response Data");
      console.log(response.data.trollyItems);
      commit("setStandingOrderTrolly", response.data.trolly);
      return response.data.success;
    } else {
      response.data.success;
    }
  },
  async createNewStandingOrder({ commit }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: orderInfo.trollyId,
      ...orderInfo.chosenDays,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post(
      "standing/create-standing-order",
      params
    );

    if (response.data.success == true) {
      commit("setSelectedStandingOrder", response.data);
      return response.data;
    } else {
      return false;
    }
  },

  async deleteStandingOrder({ state }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      soId: state.selectedStandingOrder.id,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post(
      "standing/delete-standing-order",
      params
    );

    if (response.data.success == true) {
      console.log("-- Standing Order Delete Response");
      console.log(response.data);
      return true;
    } else {
      response.data.success;
    }
  },

  async updateStandingTrollyOrderDate({ state }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      trollyId: state.selectedStandingOrder.trolly_id,
      orderDate: orderInfo,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("trolly-update-order-date", params);

    if (response.data.success == true) {
      return response.data.success;
    } else {
      return response.data;
    }
  },

  async updateSODays({ state }, orderInfo) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      soId: state.selectedStandingOrder.id,
      ...orderInfo.chosenDays,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("standing/put-standing-order", params);

    if (response.data.success == true) {
      return true;
    } else {
      return false;
    }
  },

  async enableStandingOrder({ state }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      soId: state.selectedStandingOrder.id,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post(
      "standing/enable-standing-order",
      params
    );
    return response.data;
  },

  clearSelectedStandingOrder({ commit }) {
    commit("setSelectedStandingOrder", null);
    commit("setStandingOrderTrolly", null);
  },
  clearStandingOrder({commit}){
    commit("setSelectedStandingOrder", null);
    commit("setStandingOrderTrolly", null);
    commit("setStandingOrders", []);
  }
};

const mutations = {
  setStandingOrders: (state, value) => (state.standingOrders = value),
  setSelectedStandingOrder: (state, value) =>
    (state.selectedStandingOrder = value),
  setStandingOrderTrolly: (state, value) => (state.standingOrderTrolly = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
